import styled from 'styled-components'

export const SlideChange = styled.div`
  display: flex;
  margin-left: 15px;
  cursor: pointer;

  .div1 {
    width: 20%;
  }
  .div2 {
    flex: 1;
  }
`
export const CardSwapper = styled.div`
  margin-top: 2rem;
  cursor: pointer;
  .CardItem {
    div {
      display: inline-block;
    }
    .w7 {
      width: 70%;
      word-break: break-all;
    }
    .flex1 {
      width: 30%;
    }
    .flexesb {
      display: flex;
      justify-content: space-between;
    }
  }

  .h40 {
    min-height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #dfe6ec;
  }
  .borderrb {
    border-bottom: 1px solid #dfe6ec;
  }
  .totalAmount {
    display: flex;

    .totalItem {
      width: 50%;
      height: 100%;
      border: 1px solid red;
    }

    .borderrgiht {
      border-right: 1px solid #dfe6ec;
    }
  }
`
export const CardItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  .item {
    width: 50%;
    border-bottom: 2px solid #c1e5fb;

    &:nth-child(2n + 1) {
      border-right: 2px solid #c1e5fb;
    }
    &:nth-last-child(1) {
      border-bottom: none;
    }
    &:nth-last-child(2) {
      border-bottom: none;
    }
  }
`
